<template>
  <v-group
    ref="group"
    :config="groupConfig"
    @click="onGroupClick"
    @tap="onGroupClick"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut"
    @transformend="onUpdatePosition"
    @dragend="onUpdatePosition">
    <v-text v-if="showText" :config="textConfig" />
  <!-- @dblclick="onDblClick"
  @dblTap="onDblClick" -->
  </v-group>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
    },
    offsetX: {
      default: 0
    },
    offsetY: {
      default: 0
    },
    editable: {},
  },
  data() {
    return {
      isHighlighted: false,
      showText: true,
    }
  },
  computed: {
    groupConfig() {
      return {
        draggable: this.editable,
        x: this.item.x,
        y: this.item.y,
        offsetX: this.offsetX,
        offsetY: this.offsetY,
        scaleX: this.item.scaleX || 1, /* optional */
        scaleY: this.item.scaleY || 1, /* optional */
        rotation: this.item.rotation || 0, /* optional */
      };
    },

    textConfig() {
      let defaultTextSettings = {
        fontFamily: "Arial",
        fontSize: 24,
        fill: '#ffffff',
        textDecoration: this.isHighlighted ? 'underline' : ''
      };
      let textUserConfig = {
        text: this.item.text,
        fontFamily: this.item.fontFamily,
        fontSize: this.item.fontSize
      }
      return Object.assign({}, defaultTextSettings, textUserConfig);
    }
  },
  methods: {
    onUpdatePosition(event) {
      let positionData = {
        x: parseInt( event.target.attrs.x ),
        y: parseInt( event.target.attrs.y ),
        scaleX: ( event.target.attrs.scaleX ),
        scaleY: ( event.target.attrs.scaleY ),
        rotation: parseInt( event.target.attrs.rotation ),
      }
      this.$emit('update-position',
        positionData,
        this.item.textId)
    },

    // onDblClick(event) {
    //   this.$emit('edit', this.item)
    // },

    onGroupClick(event) {
      let node = this.$refs.group.getNode();
      this.$emit('select', {
        type: 'text',
        node,
        textId: this.item.textId,
      })
    },

    onMouseOver(event) {
      document.body.style.cursor = 'pointer';
      this.isHighlighted = true;
    },

    onMouseOut(event) {
      document.body.style.cursor = 'default';
      this.isHighlighted = false;
    }
  }
}
</script>
